/**
 * Resolve locale string from Next.js route params (`lang`).
 *
 * Example Input:
 * params={ lang: 'de-de' }
 *
 * Example Output:
 * 'de-de'
 */
export function localeFromRouteParams(
  params: { lang?: string | string[] } | null | undefined
): string {
  const lang = params?.lang || 'us-en';
  return typeof lang === 'string' ? lang : 'us-en';
}
